/**
 * @fileoverview Payments route wrapper that renders the Kanban costs hub defaulted to Payments view.
 * @module features/payments/pages/PaymentsPage
 */

import type { ReactElement } from 'react'
import { CostsKanbanPage } from '@/features/costs-hub'

/**
 * PaymentsPage
 * Routes to the costs kanban view with Payments pre-selected.
 */
export default function PaymentsPage(): ReactElement {
  return <CostsKanbanPage initialPosition={2} />
}
